export class AdeMesError extends Error {
    public data: {
        error: string
    };
    public status: number;
};

export class Operator {
    public userid: number;
    public username: string;
    public propertymap: { [key: string]: boolean };
};

export class LoginBean {
    public token: string;
    public messages: Array<string>;
    public warnings: Array<string>;
    public errors: Array<string>;
}

export class IJwtPayload {
    public userId: string;
    public username: string;
    public authorizations: Array<string>;
}

export class Customer {
    public id: string;
    public name: string;
    public logourl: string;
    public backgroundcolor: string;
    public projects: Array<Project>;
    public propertymap: { [key: string]: boolean };
}

export class Project {
    public id: string;
    public label: string;
    public projectlines: Array<ProjectLine>;
    public customer?: Customer;
    public propertymap: { [key: string]: boolean };
}

export class ProjectLine {
    public id: string;
    public label: string;
    public numphasegroups: number;
    public project?: Project;
    public propertymap: { [key: string]: boolean };
}

export class PhaseGroup {
    public id: string;
    public label: string;
    public phases: Array<PhaseDetails>;
    public propertymap: { [key: string]: boolean };
}

export class PhaseDetails {
    public id: string;
    public label: string;
    public state: string;
    public qtytotal: number;
    public qtyavailable: number;
    public datestart: string;
    public propertymap: { [key: string]: boolean };
    public isWorkFinished:boolean;
    public dateend: Date;
    public workedhours: number;
    public workedminutes: number;
    public setuphours: number;
    public setupminutes: number;
    public nchours: number;
    public ncminutes: number;
    public ncreason: string;
    public ncnotes: string;
    public isblocked: boolean;
    public isattrezzaggio: boolean;

    public idcustomer: string;
    public idproject: string;
    public idprojectline: string;
    public idreport: string;
    public idphasegroup: string;

    public fullphaselabel: string;
}

export class Note {
    public id: string;
    public note: string;
    public author: string;
    public creationdate: Date;
    public propertymap: { [key: string]: boolean };
}

export class Attachment {
    public id: string;
    public type: string;
    public name: string;
    public url: string;
    public url2: string;
    public propertymap: { [key: string]: boolean };
}

export class TechnicalData {
    public id: string;
    public name: string;
    public value: string;
    public propertymap: { [key: string]: boolean };
}

export class PhaseComponent {
    public id: string;
    public name: string;
    public qta: number;
    public unit: string;
    public components?: Array<PhaseComponent>;
    public pos: number;
}

export class Report {
    public id: string;
    public date: Date;
    public customer: string;
    public numstart: number;
    public totalhours: number;
    public setuphours: number;
    public nchours: number;
    public notes: string;
    public ncnotes: string;
    public state: string;
    public progress: number;
    public progresscolor: string;
    public isblocked: boolean;
    public commessa_completa: string;
    public attributes: Array<ReportAttrib>;
    public propertymap: { [key: string]: boolean };
}

export class ReportGroup {
    public customer: string;
    public totalhours: number;
    public setuphours: number;
    public nchours: number;
    public progress: number;
    public progresscolor: string;
}

export class ReportAttrib {
    public id: string;
    public label: string;
    public value: string;
}

export class Nonconformity {
    public id: string;
    public label: string;
};

export class PhaseDescriptor {
    public customerId: string;
    public projectId: string;
    public projectLineId: string;
    public phaseId: string;
    public reportId: string;
    public state: string;
    public isWorkFinished: boolean;
    public fullphaselabel: string;

    public phaseDateStart: Date;
    public phaseHoursStart: number;
    public phaseMinutesStart: number;
    public phaseDateEnd: Date;
    public phaseHoursEnd: number;
    public phaseMinutesEnd: number;
    public phaseNote: string;
    
    public workedHours: number;
    public workedMinutes: number;

    public setupHours: number;
    public setupMinutes: number;

    public ncHours: number;
    public ncMinutes: number;

    public ncReason: string;
    public ncNotes: string;

    public propertymap: { [key: string]: boolean };

    public directStart: boolean;
    public directEnd: boolean;

    public ncPhotos: Array<any>;
    public type_nc: string;
};

export class Rfid {
    public name: string;
    public uuid: string;
};

export class RfidPhase {
    public name: string;
    public id: string;
};

export class OrderCan {
    public description: string;
    public customerid: string;
    public projectid: string;
    public projectlineid: string;
};

export class PhaseRecap {
    public customerid: string;
    public projectid: string;
    public projectlineid: string;
    public phasegroupid: string;
    public phaseid: string;
    public customer: string;
    public project: string;
    public projectline: string;
    public phase: string;
    public expectedtime: string;
    public clock: boolean;
    public progress: number;
    public progresscolor: string;
};

export class NCPhoto {
    public file: any;
    public src: any;
};

export class DatePhaseRecaps {
    public date: Date;
    public phaserecaps: Array<PhaseRecap>;
};

export class RequestVacation {
    public userId: number;
    public type: string;
    public startDate: Date;
    public endDate: Date;
};

export class ReportRequest {
    public type: string;
    public startDate: Date;
    public endDate: Date;
    public note: string;
    public stato: string;
};

export class HourWork {
    public hourwork: string;
    public hourlastreport: string;
    public url: string;
}